import { ManagedUser } from "@/services/users";

/** Confirm text before turning `user` off in the manager's organization. */
export const deactivationWarning = (user: ManagedUser) =>
  user.in_other_organizations
    ? `${user.email} stays active in their other organizations.`
    : `${user.email} won't be able to sign in until they are activated again.`;
